import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ImageRankPayload {
  previous: {
    uuid: string;
    rank: string;
  };
  next?: { 
    uuid: string;
    rank: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  private image: string | ArrayBuffer | null = null;
  private readonly imageKey = 'previewImage';

  constructor(private http: HttpClient) {}

  getImage(): string | ArrayBuffer | null {
    if (!this.image) {
      const storedImage = localStorage.getItem(this.imageKey);
      if (storedImage) {
        this.image = storedImage;
      }
    }
    return this.image;
  }

  setImage(image: string | ArrayBuffer | null): void {
    this.image = image;
    if (image) {
      localStorage.setItem(this.imageKey, typeof image === 'string' ? image : '');
    } else {
      localStorage.removeItem(this.imageKey);
    }
  }

  clearImage(): void {
    this.image = null;
    localStorage.removeItem(this.imageKey);
  }

  uploadImage(body: string, options: { headers: HttpHeaders }): Observable<any> {
    const url = `${environment.host}/ads`;
    return this.http.post(url, body,options);
  }

   listImages(imageType: string = '', language: string = ''): Observable<any> {
    let params = new HttpParams();
    if (imageType) {
      params = params.append('imageType', imageType);
    }
    if (language) {
      params = params.append('language', language);
    }
  
    const url = `${environment.host}/ads`;
    return this.http.get<any>(url, { params });
  }

  deleteImage(imageId: string): Observable<any> {
    const url = `${environment.host}/ads/${imageId}`;
    return this.http.delete(url);
  }

  updateImage(id: string, updates: any): Observable<any> {
    const url = `${environment.host}/ads/${id}`;
    return this.http.patch(url, updates);
  }
  

  updateImageRank(id: string, payload: ImageRankPayload): Observable<any>  {
    const url = `${environment.host}/ads/${id}/reorder`;
    return this.http.patch(url, payload);
  }
}
